module.exports = __webpack_public_path__ + "img/universkin-logo.1b7d233f.svg";